import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PublicIcon from "@mui/icons-material/Public";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";

const AboutOverview = () => {
  const points = [
    {
      icon: <PublicIcon sx={{ fontSize: 40 }} />,
      title: "Global Mindset",
      text: "Solid expertise empowering clients to grow in India and across international markets.",
    },
    {
      icon: <BusinessCenterIcon sx={{ fontSize: 40 }} />,
      title: "Hybrid Consultancy",
      text: "Working with businesses of all sizes, from private startups to global enterprises.",
    },
    {
      icon: <AutoGraphIcon sx={{ fontSize: 40 }} />,
      title: "Integrated Solutions",
      text: "A comprehensive one-stop platform for all your financial, taxation, audit, and advisory needs.",
    },
  ];

  return (
    <Box component="section" sx={{ py: { xs: 4, md: 6 }, bgcolor: "#fff" }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Typography
                variant="overline"
                sx={{
                  color: "var(--primary-color)",
                  fontWeight: 800,
                  letterSpacing: 2,
                  mb: 2,
                  display: "block",
                }}
              >
                Who We Are
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 800,
                  color: "#222",
                  fontFamily: "'Roboto Slab', serif",
                  fontSize: { xs: "2.2rem", md: "3rem" },
                  mb: 4,
                  lineHeight: 1.2,
                }}
              >
                Helping You Navigate the{" "}
                <span style={{ color: "var(--primary-color)" }}>
                  200+ corporates 
                </span>
              </Typography>
              <Typography
                sx={{
                  color: "#555",
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  mb: 5,
                  textAlign: "justify",
                }}
              >
                Globally minded, we offer solid expertise to empower our clients
                to take their chance on foreign markets to grow their business
                in India or elsewhere. We work with businesses of all sizes,
                privately owned or family businesses, helping them to do
                business locally and internationally.
              </Typography>
              <Link to="/about" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: "var(--primary-color)",
                    color: "var(--primary-color)",
                    px: 5,
                    py: 1.5,
                    borderRadius: "50px",
                    fontWeight: 700,
                    borderWidth: "2px",
                    "&:hover": {
                      borderWidth: "2px",
                      bgcolor: "rgba(26, 66, 161, 0.05)",
                    },
                  }}
                >
                  Discover More About Us
                </Button>
              </Link>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={3}>
              {points.map((point, index) => (
                <Grid item xs={12} key={index}>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.2 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 3,
                        p: 3,
                        borderRadius: "20px",
                        bgcolor: "#f8f9fa",
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                        },
                      }}
                    >
                      <Box sx={{ color: "var(--primary-color)" }}>
                        {point.icon}
                      </Box>
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, mb: 1, color: "#333" }}
                        >
                          {point.title}
                        </Typography>
                        <Typography sx={{ color: "#666", fontSize: "0.95rem" }}>
                          {point.text}
                        </Typography>
                      </Box>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutOverview;
